var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cakeConfig" },
    [
      _c(
        "div",
        { staticClass: "profit-box" },
        [
          _c(
            "div",
            { staticClass: "profit" },
            [
              _c("div", { staticClass: "title" }, [_vm._v("菜单级规则")]),
              _c("div", [_vm._v("可见品牌：" + _vm._s(_vm.menuTotal) + "个")]),
              _c(
                "el-button",
                {
                  attrs: { type: "text" },
                  on: {
                    click: function ($event) {
                      return _vm.openDialog("menus")
                    },
                  },
                },
                [_vm._v(" 查看明细 ")]
              ),
            ],
            1
          ),
          _vm.menuType === "orderDetails"
            ? [
                _c(
                  "div",
                  { staticClass: "profit customer" },
                  [
                    _c("div", { staticClass: "title" }, [_vm._v("客户级规则")]),
                    _vm.cakeType === "set"
                      ? _c(
                          "el-form",
                          {
                            attrs: {
                              model: _vm.profitCustomerForm,
                              disabled: true,
                              inline: "",
                            },
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  "label-width": "100px",
                                  label: "蛋糕到家利润率",
                                },
                              },
                              [
                                _c(
                                  "el-input",
                                  {
                                    staticStyle: { width: "150px" },
                                    model: {
                                      value: _vm.profitCustomerForm.ratio,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.profitCustomerForm,
                                          "ratio",
                                          $$v
                                        )
                                      },
                                      expression: "profitCustomerForm.ratio",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v("%"),
                                    ]),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      [
                        _vm._v(" 不满足利润率SKU："),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(_vm._s(_vm.profitCustomerForm.unmetTotal)),
                        ]),
                        _vm._v("个 "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openDialog("customer")
                              },
                            },
                          },
                          [_vm._v("查看明细")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "profit" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("客户级调价规则"),
                  ]),
                  _c("div", [
                    _vm._v(
                      "规则ID：" + _vm._s(_vm.profitCustomerForm.adjust_id)
                    ),
                  ]),
                  _vm.profitCustomerForm.adjust_type.includes("1")
                    ? _c("div", [
                        _vm._v(
                          " 调价比例： " +
                            _vm._s(
                              _vm.cakeType === "set"
                                ? _vm.profitCustomerForm.by_ratio_adjust + "%"
                                : "**"
                            ) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                  _vm.profitCustomerForm.adjust_type.includes("2")
                    ? _c("div", [
                        _vm._v(
                          " 调价金额：" +
                            _vm._s(
                              _vm.cakeType === "set"
                                ? _vm.profitCustomerForm.by_money_adjust
                                : "**"
                            ) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]
            : _vm._e(),
          _c("div", { staticClass: "profit" }, [
            _c("div", { staticClass: "title" }, [_vm._v("订单级城市白名单")]),
            _c("div", [
              _vm._v("白名单城市：" + _vm._s(_vm.cakeWhiteTotal) + "个"),
            ]),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.openDialog("viewCakeWhite")
                      },
                    },
                  },
                  [_vm._v(" 查看 ")]
                ),
                _vm.cakeType === "set" && _vm.hasEditRule
                  ? [
                      _c("el-divider", { attrs: { direction: "vertical" } }),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.openDialog("setCakeWhite")
                            },
                          },
                        },
                        [_vm._v(" 设置白名单 ")]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _c("div", { staticClass: "profit" }, [
            _c("div", { staticClass: "title" }, [_vm._v("订单级子菜单")]),
            _c("div", [
              _vm._v("可见菜单：" + _vm._s(_vm.childMenuTotal) + "个"),
            ]),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.openDialog("viewCakeChild")
                      },
                    },
                  },
                  [_vm._v(" 查看 ")]
                ),
                _vm.cakeType === "set" && _vm.hasEditRule
                  ? [
                      _c("el-divider", { attrs: { direction: "vertical" } }),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.openDialog("setCakeChild")
                            },
                          },
                        },
                        [_vm._v(" 设置子菜单 ")]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _c("div", { staticClass: "profit" }, [
            _c("div", { staticClass: "title" }, [_vm._v("订单级黑名单")]),
            _c("div", [
              _vm._v("黑名单品牌：" + _vm._s(_vm.blockBrandTotal) + "个"),
            ]),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.openDialog("viewBlack")
                      },
                    },
                  },
                  [_vm._v(" 查看 ")]
                ),
                _vm.cakeType === "set" && _vm.hasEditRule
                  ? [
                      _c("el-divider", { attrs: { direction: "vertical" } }),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.openDialog("setBlack")
                            },
                          },
                        },
                        [_vm._v(" 设置黑名单 ")]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "profit brand" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.tabChange },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: {
                  label: "可用品牌（" + _vm.searchForm_total + "）",
                  name: "0",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label: "可用商品（" + _vm.goodsForm_total + "）",
                  name: "1",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label: "可用sku（" + _vm.skuForm_total + "）",
                  name: "2",
                },
              }),
            ],
            1
          ),
          _vm.activeName === "0"
            ? _c(
                "div",
                [
                  _c(
                    "el-form",
                    {
                      ref: "searchForm",
                      attrs: { model: _vm.searchForm, inline: "" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "城市", prop: "region_id" } },
                        [
                          _c("el-cascader", {
                            staticStyle: { width: "120px" },
                            attrs: {
                              options: _vm.citys,
                              props: {
                                checkStrictly: true,
                                emitPath: false,
                                expandTrigger: "hover",
                              },
                              clearable: "",
                              filterable: "",
                              "popper-class": "city-style",
                            },
                            model: {
                              value: _vm.searchForm.region_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "region_id", $$v)
                              },
                              expression: "searchForm.region_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "品牌分类", prop: "category_id" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.searchForm.category_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "category_id", $$v)
                                },
                                expression: "searchForm.category_id",
                              },
                            },
                            _vm._l(_vm.categoryList, function (item) {
                              return _c("el-option", {
                                key: item.category_id,
                                attrs: {
                                  label: item.category_name,
                                  value: item.category_id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "品牌名称", prop: "brand_name" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入品牌名称",
                              clearable: "",
                            },
                            model: {
                              value: _vm.searchForm.brand_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "brand_name", $$v)
                              },
                              expression: "searchForm.brand_name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-search",
                              },
                              on: { click: _vm.searchData },
                            },
                            [_vm._v(" 搜索 ")]
                          ),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.searchData("reset")
                                },
                              },
                            },
                            [_vm._v(" 重置 ")]
                          ),
                          _vm.hasExportRole
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    exportLoading: _vm.exportLoading,
                                    type: "success",
                                  },
                                  on: { click: _vm.exportData },
                                },
                                [_vm._v(" 导出 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    staticStyle: {
                      "text-align": "right",
                      "margin-bottom": "10px",
                    },
                    attrs: {
                      background: "",
                      layout: "total, sizes, prev, pager, next, jumper",
                      "current-page": _vm.searchForm.page,
                      "page-size": _vm.searchForm.pagesize,
                      "page-sizes": [10, 20, 30, 40, 50, 100],
                      total: _vm.searchForm_total,
                    },
                    on: {
                      "size-change": function (size) {
                        return _vm.sizeChangeSearch(size)
                      },
                      "current-change": _vm.pageChangeSearch,
                    },
                  }),
                  _c(
                    "el-table",
                    {
                      key: _vm.activeName,
                      staticClass: "myTable",
                      attrs: {
                        "header-cell-style": {
                          background: "#f1f1f1",
                          color: "#333333",
                        },
                        data: _vm.tableData,
                        height: "58vh",
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "id", width: "80px", label: "ID" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "category_name", label: "分类" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "brand_name", label: "品牌" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "description",
                          label: "描述",
                          "min-width": "150px",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", { staticClass: "wrapper" }, [
                                    _c(
                                      "div",
                                      {
                                        class: [!scope.row.showMore && "text"],
                                      },
                                      [
                                        !scope.row.showMore
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "btn",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.showMore(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" 更多 ")]
                                            )
                                          : _vm._e(),
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row.description) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3798389847
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "city_name",
                          label: "覆盖城市",
                          "min-width": "180px",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", { staticClass: "wrapper" }, [
                                    _c(
                                      "div",
                                      { staticClass: "text" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "btn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.openCityDialog(
                                                  scope.row.city_tree
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" 更多 ")]
                                        ),
                                        _vm._l(
                                          scope.row.city_name,
                                          function (item, index) {
                                            return [
                                              _vm._v(
                                                _vm._s(
                                                  index !== 0 ? "，" : ""
                                                ) + _vm._s(item)
                                              ),
                                            ]
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4090628904
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "goods_count",
                          width: "80px",
                          label: "商品数量",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "sku_count",
                          width: "80px",
                          label: "SKU数量",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.activeName === "1"
            ? _c(
                "div",
                [
                  _c(
                    "el-form",
                    {
                      ref: "goodsForm",
                      staticClass: "home__search",
                      attrs: { data: _vm.goodsForm, inline: "" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "城市" } },
                        [
                          _c("el-cascader", {
                            staticStyle: { width: "120px" },
                            attrs: {
                              options: _vm.citys,
                              props: {
                                checkStrictly: true,
                                emitPath: false,
                                expandTrigger: "hover",
                              },
                              clearable: "",
                              filterable: "",
                              "popper-class": "city-style",
                            },
                            on: { change: _vm.getCityBrand },
                            model: {
                              value: _vm.goodsForm.region_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.goodsForm, "region_id", $$v)
                              },
                              expression: "goodsForm.region_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品品牌" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "input__width",
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.goodsForm.brand_code,
                                callback: function ($$v) {
                                  _vm.$set(_vm.goodsForm, "brand_code", $$v)
                                },
                                expression: "goodsForm.brand_code",
                              },
                            },
                            _vm._l(_vm.brandList, function (item) {
                              return _c("el-option", {
                                key: item.brand_code,
                                attrs: {
                                  label: item.brand_name,
                                  value: item.brand_code,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品名称" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.goodsForm.product_name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.goodsForm,
                                  "product_name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "goodsForm.product_name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否支持当日达" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "input__width",
                              attrs: { clearable: "", placeholder: "请选择" },
                              model: {
                                value: _vm.goodsForm.is_today_on,
                                callback: function ($$v) {
                                  _vm.$set(_vm.goodsForm, "is_today_on", $$v)
                                },
                                expression: "goodsForm.is_today_on",
                              },
                            },
                            _vm._l(_vm.status, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.name, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "分类" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.goodsForm.category_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.goodsForm, "category_id", $$v)
                                },
                                expression: "goodsForm.category_id",
                              },
                            },
                            _vm._l(_vm.categoryList, function (item) {
                              return _c("el-option", {
                                key: item.category_id,
                                attrs: {
                                  label: item.category_name,
                                  value: item.category_id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.searchGoodeData },
                            },
                            [_vm._v("搜 索")]
                          ),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.searchData("reset")
                                },
                              },
                            },
                            [_vm._v(" 重置 ")]
                          ),
                          _vm.hasExportRoleGoods
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    exportLoading: _vm.exportGoodsLoading,
                                    type: "success",
                                  },
                                  on: { click: _vm.exportCakeHomeGoods },
                                },
                                [_vm._v("导 出")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    staticStyle: {
                      "text-align": "right",
                      "margin-bottom": "10px",
                    },
                    attrs: {
                      background: "",
                      layout: "total, sizes, prev, pager, next, jumper",
                      "current-page": _vm.goodsForm.page,
                      "page-size": _vm.goodsForm.pagesize,
                      "page-sizes": [10, 20, 30, 40, 50, 100],
                      total: _vm.goodsForm_total,
                    },
                    on: {
                      "size-change": function (size) {
                        return _vm.sizeChangeGoods(size)
                      },
                      "current-change": _vm.pageChangeGoods,
                    },
                  }),
                  _c(
                    "el-table",
                    {
                      key: _vm.activeName,
                      staticClass: "myTable",
                      attrs: {
                        border: "",
                        "header-cell-style": {
                          background: "#f1f1f1",
                          color: "#333333",
                        },
                        align: "center",
                        height: "59vh",
                        data: _vm.goodList,
                      },
                      on: { "sort-change": _vm.sortGoodsChange },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "selection", width: "40" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "商品信息",
                          "min-width": "230px",
                          prop: "picture",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", { staticClass: "goods-info-box" }, [
                                    _c(
                                      "div",
                                      { staticClass: "image-box" },
                                      [
                                        _c("el-image", {
                                          attrs: {
                                            src: scope.row.picture,
                                            "preview-src-list": [
                                              scope.row.picture,
                                            ],
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "text" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "font-weight": "bold",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row.product_name) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        scope.row.is_today_on == 1
                                          ? _c("el-tag", [_vm._v("支持当日达")])
                                          : _vm._e(),
                                        _c("div", [
                                          _vm._v(
                                            "分类：" +
                                              _vm._s(scope.row.category_name)
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          314242831
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "排序",
                          sortable: "sort",
                          prop: "sort",
                          width: "200px",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "品牌",
                          prop: "brand_name",
                          "min-width": "150px",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "覆盖城市",
                          align: "left",
                          prop: "city_name",
                          "min-width": "400px",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", { staticClass: "wrapper" }, [
                                    _c(
                                      "div",
                                      { staticClass: "text" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "btn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.openCityDialog(
                                                  scope.row.city_tree
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" 更多 ")]
                                        ),
                                        _vm._l(
                                          scope.row.city_name,
                                          function (item, index) {
                                            return _c("span", { key: index }, [
                                              _vm._v(
                                                _vm._s(item) +
                                                  _vm._s(
                                                    index + 1 !=
                                                      scope.row.city_name
                                                        .length &&
                                                      scope.row.city_name
                                                      ? "，"
                                                      : ""
                                                  )
                                              ),
                                            ])
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1472926697
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "SKU数量",
                          sortable: "custom",
                          align: "center",
                          "sort-orders": ["descending", "ascending", null],
                          width: "110px",
                          prop: "sku_count",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.activeName === "2"
            ? _c(
                "div",
                [
                  _c(
                    "el-form",
                    {
                      ref: "skuForm",
                      staticClass: "home__search",
                      attrs: { data: _vm.skuForm, inline: "" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "城市", prop: "region_id" } },
                        [
                          _c("el-cascader", {
                            staticStyle: { width: "120px" },
                            attrs: {
                              options: _vm.citys,
                              props: {
                                checkStrictly: true,
                                emitPath: false,
                                expandTrigger: "hover",
                              },
                              clearable: "",
                              filterable: "",
                              "popper-class": "city-style",
                            },
                            on: { change: _vm.getCityBrand },
                            model: {
                              value: _vm.skuForm.region_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.skuForm, "region_id", $$v)
                              },
                              expression: "skuForm.region_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品ID" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.skuForm.goods_id,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.skuForm,
                                  "goods_id",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "skuForm.goods_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品名称" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.skuForm.product_name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.skuForm,
                                  "product_name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "skuForm.product_name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品品牌" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "input__width",
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.skuForm.brand_code,
                                callback: function ($$v) {
                                  _vm.$set(_vm.skuForm, "brand_code", $$v)
                                },
                                expression: "skuForm.brand_code",
                              },
                            },
                            _vm._l(_vm.brandList, function (item) {
                              return _c("el-option", {
                                key: item.brand_code,
                                attrs: {
                                  label: item.brand_name,
                                  value: item.brand_code,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.$hasBtnRoles("/products/cake-store/show-price") &&
                      _vm.cakeType === "set"
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "折扣" } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "80px" },
                                    attrs: {
                                      placeholder: "最低",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.skuForm.profit_ratio_gt,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.skuForm,
                                          "profit_ratio_gt",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "skuForm.profit_ratio_gt",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("span", { staticClass: "split" }, [
                                _vm._v("—"),
                              ]),
                              _c(
                                "el-form-item",
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "80px" },
                                    attrs: {
                                      placeholder: "最高",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.skuForm.profit_ratio_lt,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.skuForm,
                                          "profit_ratio_lt",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "skuForm.profit_ratio_lt",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: "售价范围" } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("el-input", {
                                staticStyle: { width: "80px" },
                                attrs: { placeholder: "最低", clearable: "" },
                                on: {
                                  input: function ($event) {
                                    return _vm.onNumberInput(
                                      "price_range",
                                      0,
                                      $event
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.skuForm.price_range[0],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.skuForm.price_range,
                                      0,
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "skuForm.price_range[0]",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("span", { staticClass: "split" }, [_vm._v("—")]),
                          _c(
                            "el-form-item",
                            [
                              _c("el-input", {
                                staticStyle: { width: "80px" },
                                attrs: { placeholder: "最高", clearable: "" },
                                on: {
                                  input: function ($event) {
                                    return _vm.onNumberInput(
                                      "price_range",
                                      1,
                                      $event
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.skuForm.price_range[1],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.skuForm.price_range,
                                      1,
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "skuForm.price_range[1]",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.$hasBtnRoles("/products/cake-store/show-price") &&
                      _vm.cakeType === "set"
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "结算价范围" } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "80px" },
                                    attrs: {
                                      placeholder: "最低",
                                      clearable: "",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.onNumberInput(
                                          "clearing_range",
                                          0,
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.skuForm.clearing_range[0],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.skuForm.clearing_range,
                                          0,
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "skuForm.clearing_range[0]",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("span", { staticClass: "split" }, [
                                _vm._v("—"),
                              ]),
                              _c(
                                "el-form-item",
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "80px" },
                                    attrs: {
                                      placeholder: "最高",
                                      clearable: "",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.onNumberInput(
                                          "clearing_range",
                                          1,
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.skuForm.clearing_range[1],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.skuForm.clearing_range,
                                          1,
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "skuForm.clearing_range[1]",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: "类型" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.skuForm.sku_name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.skuForm,
                                  "sku_name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "skuForm.sku_name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "分类" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.skuForm.category_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.skuForm, "category_id", $$v)
                                },
                                expression: "skuForm.category_id",
                              },
                            },
                            _vm._l(_vm.categoryList, function (item) {
                              return _c("el-option", {
                                key: item.category_id,
                                attrs: {
                                  label: item.category_name,
                                  value: item.category_id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.searchData },
                            },
                            [_vm._v("搜 索")]
                          ),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.searchData("reset")
                                },
                              },
                            },
                            [_vm._v(" 重置 ")]
                          ),
                          _vm.hasExportRoleSku
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    exportLoading: _vm.exportSkuLoading,
                                    type: "success",
                                  },
                                  on: { click: _vm.exportCakeHomeSku },
                                },
                                [_vm._v("导 出")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    staticStyle: {
                      "text-align": "right",
                      "margin-bottom": "10px",
                    },
                    attrs: {
                      background: "",
                      layout: "total, sizes, prev, pager, next, jumper",
                      "current-page": _vm.skuForm.page,
                      "page-size": _vm.skuForm.pagesize,
                      "page-sizes": [10, 20, 30, 40, 50, 100],
                      total: _vm.skuForm_total,
                    },
                    on: {
                      "size-change": function (size) {
                        return _vm.sizeChangeSku(size)
                      },
                      "current-change": _vm.pageChangeSku,
                    },
                  }),
                  _c(
                    "el-table",
                    {
                      staticClass: "myTable",
                      attrs: {
                        border: "",
                        height: "59vh",
                        "header-cell-style": {
                          background: "#f1f1f1",
                          color: "#333333",
                        },
                        align: "center",
                        data: _vm.skuList,
                      },
                      on: { "sort-change": _vm.sortSkuChange },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "商品图片",
                          width: "100px",
                          prop: "channel_pre_discount",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-image", {
                                    attrs: {
                                      src: scope.row.picture,
                                      "preview-src-list": [scope.row.picture],
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2525942162
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "商品信息",
                          width: "250px",
                          prop: "channel_pre_discount",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      "商品ID：" + _vm._s(scope.row.goods_id)
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      "品牌：" + _vm._s(scope.row.brand_name)
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      "名称：" + _vm._s(scope.row.product_name)
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      "分类：" + _vm._s(scope.row.category_name)
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1940298825
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "类型", prop: "sku_name" },
                      }),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            label: "商城售价",
                            prop: "price",
                            sortable: "custom",
                            align: "center",
                            "sort-orders": ["descending", "ascending", null],
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "header" },
                            [
                              _c("span", [_vm._v("商城售价")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "商品在商城中销售的价格",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon el-icon-warning-outline",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            label: "市场价",
                            prop: "market_price",
                            sortable: "custom",
                            align: "center",
                            "sort-orders": ["descending", "ascending", null],
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "header" },
                            [
                              _c("span", [_vm._v("市场价")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "该商品在市场上销售的售价",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon el-icon-warning-outline",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                      _vm.$hasBtnRoles("/products/cake-store/show-price") &&
                      _vm.cakeType === "set"
                        ? _c(
                            "el-table-column",
                            {
                              attrs: {
                                label: "结算价",
                                prop: "clearing_price",
                                sortable: "custom",
                                align: "center",
                                "sort-orders": [
                                  "descending",
                                  "ascending",
                                  null,
                                ],
                              },
                            },
                            [
                              _c(
                                "template",
                                { slot: "header" },
                                [
                                  _c("span", [_vm._v("结算价")]),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: "平台与渠道结算的价格",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon el-icon-warning-outline",
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.$hasBtnRoles("/products/cake-store/show-price") &&
                      _vm.cakeType === "set"
                        ? _c("el-table-column", {
                            attrs: {
                              label: "折扣",
                              prop: "channel_pre_discount",
                              sortable: "custom",
                              align: "center",
                              "sort-orders": ["descending", "ascending", null],
                            },
                          })
                        : _vm._e(),
                      _c("el-table-column", {
                        attrs: { label: "赠品", prop: "gift" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showCityDialog,
            title: "覆盖城市",
            "lock-scroll": "",
            "append-to-body": "",
            top: "30px",
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCityDialog = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "treeContent" },
            [
              _c(
                "div",
                { staticClass: "filter-input" },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "输入关键字进行过滤" },
                    model: {
                      value: _vm.filterText,
                      callback: function ($$v) {
                        _vm.filterText =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "filterText",
                    },
                  }),
                ],
                1
              ),
              _c("el-tree", {
                ref: "tree",
                staticClass: "filter-tree",
                attrs: {
                  data: _vm.cityList,
                  props: {
                    children: "children",
                    label: "label",
                  },
                  "filter-node-method": _vm.filterNode,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showCityDialog = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.menuDialog,
            title: "菜单级规则可见品牌（蛋糕到家）",
            "lock-scroll": "",
            "append-to-body": "",
            top: "20px",
            width: "1100px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.menuDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "menuDialogForm",
              attrs: { model: _vm.menuDialogForm, inline: "" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "城市", prop: "region_id" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.citys,
                      props: {
                        checkStrictly: true,
                        emitPath: false,
                        expandTrigger: "hover",
                      },
                      clearable: "",
                      filterable: "",
                      "popper-class": "city-style",
                    },
                    model: {
                      value: _vm.menuDialogForm.region_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.menuDialogForm, "region_id", $$v)
                      },
                      expression: "menuDialogForm.region_id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "品牌分类", prop: "category_id" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.menuDialogForm.category_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.menuDialogForm, "category_id", $$v)
                        },
                        expression: "menuDialogForm.category_id",
                      },
                    },
                    _vm._l(_vm.categoryList, function (item) {
                      return _c("el-option", {
                        key: item.category_id,
                        attrs: {
                          label: item.category_name,
                          value: item.category_id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "品牌名称", prop: "brand_name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入品牌名称", clearable: "" },
                    model: {
                      value: _vm.menuDialogForm.brand_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.menuDialogForm, "brand_name", $$v)
                      },
                      expression: "menuDialogForm.brand_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.searchMenuList(1)
                        },
                      },
                    },
                    [_vm._v(" 搜索 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.searchMenuList(1, { type: "reset" })
                        },
                      },
                    },
                    [_vm._v(" 重置 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticClass: "myTable",
              attrs: {
                "header-cell-style": {
                  background: "#f1f1f1",
                  color: "#333333",
                },
                data: _vm.menuBrandList,
                height: "59vh",
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", width: "80px", label: "ID" },
              }),
              _c("el-table-column", {
                attrs: { prop: "category_name", label: "分类" },
              }),
              _c("el-table-column", {
                attrs: { prop: "brand_name", label: "品牌" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "city_name",
                  label: "覆盖城市",
                  "min-width": "180px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "wrapper" }, [
                          _c(
                            "div",
                            { staticClass: "text" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openCityDialog(
                                        scope.row.city_tree
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" 更多 ")]
                              ),
                              _vm._l(
                                scope.row.city_name,
                                function (item, index) {
                                  return [
                                    _vm._v(
                                      _vm._s(index !== 0 ? "，" : "") +
                                        _vm._s(item)
                                    ),
                                  ]
                                }
                              ),
                            ],
                            2
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "10px" } },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.menuDialogForm.page,
                  "page-size": _vm.menuDialogForm.pagesize,
                  "page-sizes": [10, 20, 30, 40, 50, 100],
                  total: _vm.menuDialogForm.total_count,
                },
                on: {
                  "size-change": function (size) {
                    return _vm.sizeChange("menuDialogForm", size)
                  },
                  "current-change": _vm.searchMenuList,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "cake__dialog",
          attrs: {
            top: "7vh",
            title: "设置品牌黑名单",
            visible: _vm.cakeDialog,
            width: "640px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.cakeDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("div", { staticClass: "checked__cake" }, [
                _c("div", { staticClass: "checked__margin" }, [
                  _vm._v(" 已选品牌 "),
                  _vm.dialogType === "setBlack" && _vm.checkedCakes.length
                    ? _c(
                        "span",
                        {
                          staticClass: "clear",
                          on: { click: _vm.clearChecked },
                        },
                        [_vm._v("清空已选")]
                      )
                    : _vm._e(),
                ]),
                _vm.checkedCakes.length
                  ? _c(
                      "div",
                      _vm._l(_vm.checkedCakes, function (item, index) {
                        return _c(
                          "el-button",
                          {
                            key: item.id,
                            staticStyle: { margin: "0 10px 10px 0" },
                            attrs: { type: "info", size: "small", plain: "" },
                            on: {
                              click: function ($event) {
                                return _vm.delCheckedCake(index)
                              },
                            },
                          },
                          [
                            _vm._v(" " + _vm._s(item.brand_name) + " "),
                            _vm.dialogType === "setBlack"
                              ? _c("span", {
                                  staticClass: "btn-icon el-icon-close",
                                })
                              : _vm._e(),
                          ]
                        )
                      }),
                      1
                    )
                  : _c("div", { staticClass: "empty__style" }, [
                      _vm._v("暂未选择品牌！"),
                    ]),
              ]),
              _c("div", { staticClass: "wait__margin" }, [_vm._v("待选品牌")]),
              _c(
                "div",
                [
                  _vm._v(" 品牌名称："),
                  _c("el-input", {
                    staticStyle: { width: "210px", margin: "5px 3px" },
                    attrs: { clearable: "", placeholder: "请选择不支持的品牌" },
                    model: {
                      value: _vm.searchBrand.brand_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchBrand, "brand_name", $$v)
                      },
                      expression: "searchBrand.brand_name",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "medium",
                        icon: "el-icon-search",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.searchCakeList(1)
                        },
                      },
                    },
                    [_vm._v("搜索")]
                  ),
                  _vm.dialogType === "setBlack"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "medium" },
                          on: { click: _vm.batchAddCake },
                        },
                        [_vm._v("批量添加")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  attrs: {
                    data: _vm.cakeList,
                    border: "",
                    height: "400px",
                    "header-cell-style": {
                      color: "#333333",
                      background: "#f1f1f1",
                    },
                  },
                  on: {
                    "select-all": _vm.handleSelectCake,
                    select: _vm.handleSelectCake,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      selectable: _vm.selectable,
                      width: "55",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "id", width: "80px", label: "ID" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "brand_name", label: "品牌" },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "right",
                    "margin-bottom": "10px",
                    "margin-top": "10px",
                  },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "prev, pager,sizes, jumper, next",
                      "page-sizes": [20, 2000],
                      "page-size": _vm.searchBrand.pagesize,
                      total: _vm.searchBrand.total_count,
                    },
                    on: {
                      "size-change": function (size) {
                        return _vm.sizeChange("searchBrand", size)
                      },
                      "current-change": _vm.searchCakeList,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { "margin-top": "-25px" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.cakeDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.dialogType !== "setBlack" || !_vm.hasEditRule,
                  },
                  on: { click: _vm.setBlackCake },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }